<div class="item-view embedded-item">
  <div class="main-block">
    <div class="item-view-top justify-content">
      <div class="flex-start">
        <ol class="breadcrumb" *ngIf="content.entityType === 'CITATION'">
          <li>
            {{ content?.listName }}
          </li>
          <li>
            <i class="fa fa-angle-right"></i>
            {{ content?.sectionName }}
          </li>
        </ol>
        <ol class="breadcrumb" *ngIf="content.entityType === 'COLLECTION'">
          <li>{{ 'favorites.title' | translate }}</li>
        </ol>
      </div>
      <div class="flex-end">
        <div class="flex-end text-right">
          <div *ngIf="!isGuest" class="user-initials-menu" tooltip="{{ user.fullUserDisplayName }}">
            <span class="user-initials">
              {{ user.initials }}
            </span>
          </div>
          <button
            *ngIf="isGuest"
            class="btn btn-primary btn-hover dropdown-toggle"
            ng-class="{ 'auto-width white-btn': isGuest, 'white-btn': isDarkColor(user.cusBranding.topcolor), 'regular-link': !isDarkColor(user.cusBranding.topcolor) }"
            data-toggle="uib-dropdown"
            role="button"
            uib-dropdown-toggle
            tabindex="0"
            id="userSettingsDropdown"
            uib-tooltip="{{ 'main.menu.login' | translate }}"
            tooltip-placement="bottom"
            tooltip-trigger="'focus mouseenter'"
            (click)="onLogin()">
            <span>{{ 'main.menu.login' | translate }}</span>
          </button>
        </div>

        <div class="justify-content flex-wrap">
          <div class="flex-basis">
            <button *ngIf="showDownload" (click)="download()" class="btn-link no-padding span-link-item" id="viewOnlinDownloadLinkBtn" role="button" tabindex="0" stop-event>
              <i class="fa fa-cloud-download breif-hidden" aria-hidden="true"></i>
              {{ 'general.download' | translate }}
              <span class="location breif-hidden" *ngIf="content?.amazonFileKey">({{ content?.amazonFileKey.substr(content?.amazonFileKey.lastIndexOf('.') + 1) }})</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="media">
      <div class="media-body no-padding">
        <div class="media-heading">
          <div class="citation-title justify-content">
            <div class="flex-start">
              <h1 class="media-title">{{ content?.title }}</h1>
            </div>
            <div class="flex-end" *ngIf="content.entityType !== 'COLLECTION' && showReportBroken">
              <button (click)="reportBrokenLink()" class="btn-link no-padding span-link-item" id="viewOnlineReportBrokenLinkBtn" role="button" tabindex="0" stop-event>
                <i class="fa fa-chain-broken breif-hidden" aria-hidden="true"></i>
                {{ 'menu.markAsBrokenClicked' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p class="error-message semi-large-text" *ngIf="content?.sanitizeFile">
  <i class="fa fa-ban"></i> {{ (isGuest ? 'viewer.file.copyright.not.approved.msg.guest' : student ? 'viewer.file.copyright.not.approved.msg.student' : 'viewer.file.copyright.not.approved.msg.instructor') | translate }}
</p>
<div class="justify-content border-bottom-link" *ngIf="content.entityType !== 'COLLECTION'">
  <div class="flex-start" *ngIf="annotator.displayPrivatePublicTabs">
    <rl-annotations-pills [allowAnnotations]="content?.allowAnnotations" (annotationSwitch)="annotationSwitch($event)"></rl-annotations-pills>
  </div>
  <div class="flex-end padding-half-right" *ngIf="displayAnnottaionToggel() && !student">
    <rl-toggle-button [id]="'TOGGLE'" [active]="content?.allowAnnotations" [stateLabels]="{ on: 'toolbar.toggle.publicAnnotations', off: 'toolbar.toggle.publicAnnotations' }" (onChange)="onChangeAnnotationToggle($event)"></rl-toggle-button>
  </div>
</div>
<div class="section-block object-block embedded-item-content">
  <div class="embedded-content">
    <div class="pdf-viewer-holder" *ngIf="content && !content.sanitizeFile">
      <!--ng-if="pdfFile">  [public-annotations]="publicAnnotations" -->
      <rl-embedded-view [file]="content" [annotatorConfig]="annotator" class="pdfViewerDiv"></rl-embedded-view>
    </div>
  </div>
</div>
